import React from "react";

const Bash_Kill = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Kill</h2>
      <p>Send signals to processes (commonly used to terminate).</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>kill [options] pid
kill -9 pid  # force</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>kill 1234
kill -9 1234</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Try gentler signals before -9 (SIGKILL).</p>
    </div>
  );
};

export default Bash_Kill;
